export const FEATURES = {
  CONTACTS: 'contacts',
  SUGGEST_CONTENT: 'suggest-content',
  SUGGEST_KEYWORDS: 'suggest-keywords',
  IMPROVED_SEARCH: 'improved-search',
  SEARCH_V2: 'search-v2',
  TERMS_AND_CONDITIONS: 'terms-and-conditions',
  ROTATIONS: 'rotations',
  SCHEDULE_ASSIGNMENTS: 'schedule-assignments',
  SCHEDULE_EDUCATIONAL_EVENTS: 'schedule-educational-events',
  KNOWLEDGE_ITEMS_EMBEDDINGS: 'knowledge-items-embeddings',
  AI_ASK_PANDA: 'ai-ask-panda',
  APPROVAL_MARK: 'approval-mark',
  AVATARS: 'avatars',
  AUTO_EXTRACT_METADATA: 'auto-extract-metadata',
  KNOWLEDGE_HUB_SHARED: 'knowledge-hub-shared',
  KNOWLEDGE_HUB_ACCESS: 'knowledge-hub-access',
  PERMISSIONS_OWNER_RESTRICTION: 'permissions-owner-restriction',
  KNOWLEDGE_COMMENTS: 'knowledge-comments',
  PROVIDED_BY: 'provided-by',
  WORKSPACE_RESTRICTIONS: 'workspace-restrictions',
  QUALITY_METRICS: 'quality-metrics',
  MY_CONTENT: 'my-content',
  QUALITY_METRICS_CASES: 'quality-metrics-cases',
  DOCUMENT_EDITOR: 'document-editor',
  ALLOW_KNOWLEDGE_TREE_COPY: 'allow-knowledge-tree-copy',
  PANDA_NO_FTS: 'panda-no-fts',
  PANDA_PARALLEL_GEN: 'panda-parallel-gen',
  PANDA_USE_GPT54_MINI: 'panda-use-gpt54-mini',
  PANDA_FAST_VECTOR_SEARCH: 'panda-fast-vector-search',
  PANDA_V2: 'panda-v2',
  POLICYTECH: 'policytech',
};
